import React, {Component} from 'react';
import PropTypes from "prop-types";
import {getCurrentMicroTime} from "../../../reducers/timeMeasuring/actions";
import {CardBody} from "reactstrap";
import AnswerContainer from "../answer-area/Components/answerContainer";
import QuestionContainer from "../answer-area/Components/questionContainer";
import {setSurveyNavShowNextButton} from "../../../reducers/surveyNav/actions";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

class Excludings extends Component {

	constructor(props) {
		super(props);

		this.selectExcluding = this.selectExcluding.bind(this);
	}

	selectExcluding(excluding) {
		const microTime = getCurrentMicroTime(this.props.startTime);
		this.props.onExcludingChanged(excluding, microTime);
	}

	render() {
		const {excludings, selected, question, setSurveyNavShowNextButton} = this.props;

		return (
			<React.Fragment>
				<CardBody className={"answer-area pt-sm-0 excluding-answer-area"}>
					<QuestionContainer classes={"pt-sm-0"} component={
						<React.Fragment>
							{excludings.map(excluding => {
								return <AnswerContainer
									classes={"p-0"}
									answer={excluding}
									checked={selected && selected === excluding.id}
									onClick={() => {
										if (question.type === 'matrix' || question.type === 'matrixMulti' || question.type === 'matrixDropdown') {
											setSurveyNavShowNextButton(true);
										}

										this.selectExcluding(excluding.id)
									}}
									component={
										<div className={"d-flex align-items-center h-100"}>
											<span className={"w-100"} dangerouslySetInnerHTML={{__html: excluding.content}}/>
										</div>
									}
								/>
							})}
						</React.Fragment>
					} />
				</CardBody>
			</React.Fragment>
		)
	}
}

Excludings.propTypes = {
	onExcludingChanged: PropTypes.func.isRequired,
	excludings: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		content: PropTypes.string.isRequired
	}),).isRequired,
	selected: PropTypes.number.isRequired,
	startTime: PropTypes.number.isRequired
};

function mapStateToProps(state) {
	return {
	}
}

export default connect(mapStateToProps, {setSurveyNavShowNextButton})(injectIntl(Excludings));